import register from '../../../../global/js/registry';
export default register('m-formstep-resume-slice', () => import(/* webpackMode: "lazy" */ './m-formstep-resume-slice.controller'));
